import React from "react";

const Video = () => {
  return (
    <div>
      <h1>Video</h1>
      <p>nevimmm</p>
    </div>
  );
};

export default Video;